// import reduced images
import img1 from '../myImages/thumbnailsGallery/1.jpg';
import img2 from '../myImages/thumbnailsGallery/2.jpg';
import img3 from '../myImages/thumbnailsGallery/3.jpg';
import img4 from '../myImages/thumbnailsGallery/4.jpg';
import img5 from '../myImages/thumbnailsGallery/5.jpg';
import img6 from '../myImages/thumbnailsGallery/6.jpg';
import img7 from '../myImages/thumbnailsGallery/7.jpg';
import img8 from '../myImages/thumbnailsGallery/8.jpg';
import img9 from '../myImages/thumbnailsGallery/9.jpg';
import img10 from '../myImages/thumbnailsGallery/10.jpg';
import img11 from '../myImages/thumbnailsGallery/11.jpg';
import img12 from '../myImages/thumbnailsGallery/12.jpg';

export const galleryThumbnails = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12 
];